import { render, staticRenderFns } from "./EditTermModal.vue?vue&type=template&id=ca7f838e&scoped=true&"
import script from "./EditTermModal.vue?vue&type=script&lang=js&"
export * from "./EditTermModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7f838e",
  null
  
)

export default component.exports